import { createUseStyles } from 'react-jss'

const styles = {
	container: {
		display: 'flex',
		maxWidth: '100% !important',
		flexWrap: 'wrap',
		padding: '2rem',
		justifyContent: 'center',
	},
}

export default createUseStyles(styles)
